import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13.7 18"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.61 4.92 9.06 1.47a.304.304 0 0 0-.21-.08H1.71c-.39 0-.71.32-.71.71v12.85c0 .39.32.71.71.71h10.27c.39 0 .71-.32.71-.71V5.13a.265.265 0 0 0-.08-.21zm-.51 10.03c0 .06-.05.11-.11.11H1.71c-.06 0-.11-.05-.11-.11V2.1c0-.06.05-.11.11-.11h7.02l3.36 3.27v9.69z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.35 6.6c-.52-.52-1.21-.8-1.94-.8H6.4c-1.52 0-2.75 1.24-2.75 2.75 0 .73.29 1.42.81 1.94s1.21.8 1.94.8h.01c.62 0 1.18-.21 1.64-.56l1.47 1.47c.06.06.14.09.21.09s.15-.03.21-.09a.29.29 0 0 0 0-.42l-1.46-1.46c.41-.48.67-1.1.67-1.78.01-.73-.28-1.42-.8-1.94zm-1.94 4.1a2.1 2.1 0 0 1-1.52-.63c-.4-.41-.63-.95-.63-1.52 0-1.19.96-2.15 2.15-2.15.57 0 1.11.22 1.52.63.41.41.63.95.63 1.52 0 1.18-.96 2.14-2.15 2.15z"
    }, null, -1)
  ])))
}
export default { render };